import { service } from "@server/client";
import type {
  ClearCartMutation,
  ClearCartMutationVariables,
} from "@server/gql/graphql";
import { clearCartMutation } from "@server/queries/cart";

export const clearCart = async (variables: ClearCartMutationVariables) => {
  try {
    const response = await service<
      ClearCartMutation,
      ClearCartMutationVariables
    >({
      query: clearCartMutation,
      variables,
    });

    return response.cart;
  } catch (error: Error | unknown) {
    console.error("Error in clearCart", error);
    throw error;
  }
};
